// src/MyChart.js
import React, { useRef, useEffect, memo } from 'react';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import { Rectangle } from '@amcharts/amcharts4/core';  // Import Rectangle for the box

const Chart = ({financials_data, active_chart, is_bu_chart}) => {

  // console.log("total_revenue ", financials_data, "active_chart : ", active_chart)

  const BAR_CORNER_SIZE = 12;

  const chartRef = useRef(null);

  useEffect(() => {
    // Create chart instance
    am4core.addLicense("CH227954864");
    const chart = am4core.create(chartRef.current, am4charts.XYChart);
    let chart_data = financials_data;

    // Add data
    // chart.data = [
    //   { category: "2019", value: 90 },
    //   { category: "2020", value: 70 },
    //   { category: "2021", value: 10 },
    //   { category: "2022", value: 60 },
    //   { category: "2023", value: 100 }
    // ];
    
    chart_data = chart_data.map(item => ({
      ...item,
      value: item.value == null ? "NA" : item.value
    }));

    const allNegative = chart_data.every(item => item.value < 0);

    chart.data = chart_data;

    // Create category axis (X-axis)
    const categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
    categoryAxis.dataFields.category = "category";

    // Create value axis (Y-axis)
    const valueAxis = chart.yAxes.push(new am4charts.ValueAxis());

    valueAxis.min = 0;
    valueAxis.extraMax = 0.1;

    //Display all labels on X-axis
    categoryAxis.renderer.minGridDistance = 30;

    categoryAxis.renderer.labels.template.adapter.add("text", function(text, target) {
      if (target.dataItem && target.dataItem.category) {
        return target.dataItem.category.toString();
      }
      return text;
    });
    
    // Create series
    const series = chart.series.push(new am4charts.ColumnSeries());
    series.dataFields.valueY = "value";
    series.dataFields.categoryX = "category";
    series.name = "Value";

    // Conditionally make columns transparent if all values are negative
  // series.columns.template.adapter.add("fillOpacity", (opacity, target) => {
  //   if (allNegative) {
  //     return 0; // Make bars fully transparent
  //   }
  //   return opacity;
  // });

  series.columns.template.adapter.add("strokeOpacity", (opacity, target) => {
    if (allNegative) {
      return 0; // Hide the border of bars
    }
    return opacity;
  });

    // Define the tooltip HTML
    let tooltipHtml = `
      <div class="tooltipDiv" style="background-color: #fff !important; padding: 0px; border-radius: 5px; font-size:12px; z-index:999;opacity:1;">
        <strong>Year:</strong> {categoryX}<br>
        <strong> Revenue:</strong> {valueY}
      </div>
    `;

    // Customize the tooltip
    series.columns.template.tooltipHTML = tooltipHtml; // Set the custom HTML tooltip

    // Configure tooltip appearance
    series.tooltip.getFillFromObject = false;
    series.columns.template.tooltipY = 0; // Align tooltip with the top of the bar
    series.columns.template.tooltipX = 20; // Adjust tooltip position to the right
    series.tooltip.label.fill = am4core.color("#000000");

    // Customize the color of the bars
    series.columns.template.fill = am4core.color("#69ae72"); // Set a single color

    series.columns.template.adapter.add("fill", function(fill, target) {
      if (target.dataItem && (target.dataItem.valueY < 0)) {
        // return am4core.color("#69ae72");
        return am4core.color("#a55");
      }else {
        return fill;
      }
    });
    
    // Customize bar width and style
    series.columns.template.width = 40; // Adjust bar width here
    series.columns.template.maxWidth = 120; // Optional: Max width for responsiveness
    // series.columns.template.stroke = am4core.color("#FF5733"); // Set the border color
    series.columns.template.strokeWidth = 0; // Stroke width

    categoryAxis.renderer.labels.template.fill = am4core.color("#475569");
    categoryAxis.renderer.labels.template.fontSize = 12;
    categoryAxis.renderer.labels.template.fontFamily = 'Inter';
    categoryAxis.renderer.labels.template.fontWeight = '600';
    categoryAxis.renderer.grid.template.strokeDasharray = "3,3";
    categoryAxis.renderer.grid.template.color = am4core.color("#e2e8ed");

    categoryAxis.renderer.labels.template.verticalCenter = "middle";  // Align labels vertically
    categoryAxis.renderer.minHeight = 40; // Adjust minimum height for the labels
    categoryAxis.renderer.labels.template.paddingTop = 20;  // Add padding to avoid overlap

    valueAxis.renderer.labels.template.visible = false; // Hide labels on Y-axis

    valueAxis.renderer.labels.template.fill = am4core.color("#475569");
    valueAxis.renderer.labels.template.fontSize = 12;
    valueAxis.renderer.labels.template.fontFamily = 'Inter';
    valueAxis.renderer.labels.template.fontWeight = '600';
    valueAxis.renderer.grid.template.strokeDasharray = "3,3";

    // ++++++++++++
    // valueAxis.min = -0.5; // Allow space for negative values
    valueAxis.maxExtra = 1;
    // ++++++++++++
    // categoryAxis.renderer.line.strokeOpacity = 1;

    // Remove base grid line which is getting display in the middle of the graph
    if(allNegative){
      categoryAxis.renderer.line.strokeOpacity = 0.1;
      //valueAxis.renderer.line.strokeOpacity = 0; // Hides the axis line
      valueAxis.renderer.baseGrid.disabled = true;
    }

    // valueAxis.renderer.autoGridCount = false;
    // valueAxis.renderer.gridCount = 5;

    // valueAxis.renderer.autoGridCount = false; // Disable automatic grid count
    // valueAxis.renderer.gridCount = 3; 
    // valueAxis.renderer.grid.template.disabled = true;

    /*
    if (allNegative) {
      // If all values are negative, invert the Y-axis scale
      valueAxis.min = am4core.math.min(chart_data.map(item => item.value)); // Set minimum to the lowest value
      valueAxis.max = am4core.math.max(chart_data.map(item => item.value)); // Set minimum to the lowest value
      valueAxis.renderer.inversed = true; // Flip the axis
      valueAxis.renderer.inside = true; // Move the labels inside the chart
      // valueAxis.extraMax = 0.1; // Add some padding above
    } else {
      valueAxis.min = 0; // Default minimum value
      valueAxis.extraMax = 0.1; // Add some padding above
    }
    */

    // Default Bar Top Left and Top Right Corner
    series.columns.template.column.cornerRadiusTopLeft = BAR_CORNER_SIZE;
    series.columns.template.column.cornerRadiusTopRight = BAR_CORNER_SIZE;
    
    // Adapter for conditional corner radius on the top left side
    series.columns.template.column.adapter.add("cornerRadiusTopLeft", function(cornerRadius, target) {
      if (target.dataItem && target.dataItem.valueY < 0) {
        return 0;
      }
      return BAR_CORNER_SIZE;
    });

    // Adapter for conditional corner radius on the top right side
    series.columns.template.column.adapter.add("cornerRadiusTopRight", function(cornerRadius, target) {
      if (target.dataItem && target.dataItem.valueY < 0) {
        return 0;
      }
      return BAR_CORNER_SIZE;
    });

    // Adapter for conditional corner radius on the bottom left side
    series.columns.template.column.adapter.add("cornerRadiusBottomLeft", function(cornerRadius, target) {
      if (target.dataItem && target.dataItem.valueY < 0) {
        return BAR_CORNER_SIZE;
      }
      return 0;
    });

    // Adapter for conditional corner radius on the bottom right side
    series.columns.template.column.adapter.add("cornerRadiusBottomRight", function(cornerRadius, target) {
      if (target.dataItem && target.dataItem.valueY < 0) {
        return BAR_CORNER_SIZE;
      }
      return 0;
    });

    // const label = series.columns.template.createChild(am4core.Label);
    // label.text = "{valueY}";
    // label.align = "center";
    // ++++++++++++++++++++++
    // label.valign = "top";

    // ++++++++++++++++++++++

    // label.fill = am4core.color("#000");
    // label.fontSize = 12;
    // label.fontFamily = 'Inter';
    // label.fontWeight = '600';
    // +++++++++++++++++++
    // valueAxis.min = '0';
    // valueAxis.max = '-30';
    // label.dy = -15;
    // Adjust label position dynamically based on the Y-value (positive or negative)
    // series.columns.template.adapter.add("dy", (dy, target) => {
    //   const label = target.children.getIndex(0); // Accessing the label element
    //   if (label) {

    //     label.text = '{valueY}';
    //     label.horizontalCenter = 'middle';
    //     label.verticalCenter = 'bottom'; // Position the label above the top of the bar

    //     // If the value is negative
    //     if (target.dataItem.valueY < 0) {
    //       label.valign = "bottom";  // Align label vertically in the middle
    //       label.dy = 0;  // Move label further to the right (after the negative bar end)
    //     } else {
    //       label.valign = "top";  // Align label to the top for positive values
    //       label.dy = 0;  // Move label further to the right (after the negative bar end)
    //     }
    //   }
    //   return dy;
    // });


    // Restrict negative values to 0, but display their labels
    series.columns.template.adapter.add("valueY", function(value, target) {
      if (value < 0) {
        target.dataItem.valueY = 0;  // Restrict negative bars to 0 height
      }
      return value;
    });

    //Separate label created because bar alignment is getting disturbed due to change in labels position
    let labelBullet =  series.columns.template.createChild(am4core.Label);
    labelBullet.fill = am4core.color("#000");
    labelBullet.fontSize = 12;
    labelBullet.fontFamily = 'Inter';
    labelBullet.fontWeight = '600';
    labelBullet.text = '{valueY}';
    labelBullet.adapter.add("text", (text, target) => {
      return target.dataItem.dataContext.value === "NA" ? "NA" : text;
    });
    labelBullet.horizontalCenter = 'middle';
    labelBullet.verticalCenter = 'bottom';  // Align label at the top of the bar
    // labelBullet.dy = 1;  // Move label 10px above the top of the bar

    labelBullet.adapter.add('fill', (x, target) => {
      if (target.dataItem && target.dataItem.valueY < 0) {
        return am4core.color("#a55"); // Color for negative values
      } else {
        return am4core.color("#000"); // Color for positive values
      }
    });

    // Adjust the label position based on the value (above for positive, below for negative)
    labelBullet.adapter.add('dy', (dy, target) => {
      let value = target.dataItem.values.valueY.value;

      // Move label above for positive values and below for negative values
      if (value >= 0) {
        return dy;  // Move label 10px above for positive values
      } else {
        return dy;  // Move label 10px below for negative values
      }
    });

    // Manually adjust the horizontal position of the label to keep it centered
    labelBullet.adapter.add('x', (x, target) => {
      let column = target.dataItem.column;
      if (column) {
        return column.pixelWidth / 2;  // Align the label horizontally with the middle of the column
      }
      return x;
    });

    // labelBullet.y = 20;

    // Adjust the label position based on the value (above for positive, below for negative)
    series.columns.template.adapter.add('y', (y, target) => {
      let value = target.dataItem.values.valueY.value;

      // Move label above for positive values and below for negative values
      if (value >= 0) {
        return y;
      } else {
        return 240;
      }
    });

    // This keeps the column's starting position unaffected
    // series.columns.template.adapter.add('y', (y, target) => {
    //   return y; // No change to the Y position of the bars
    // });
    // +++++++++++++++++++

    //Update value axis labels
    chart.numberFormatter.numberFormat = "#,###";

    chart.paddingBottom = 0;
    chart.paddingLeft = -50;

    // Add a box (border) around the chart
    const box = chart.plotContainer.createChild(Rectangle);
    box.width = am4core.percent(100);  // Make the box take the full width
    box.height = am4core.percent(107); // Make the box take the full height
    box.stroke = am4core.color("#e2e8ed"); // Set the stroke (border) color
    box.strokeWidth = 1;  // Set the border width
    box.strokeDasharray = "3,3";
    box.fill = am4core.color("#fff"); // Set the fill color of the box (transparent)
    
    // Ensure the rectangle is behind the grid and chart content
    box.toBack();  // Moves the box to the back

    // Adjust the plotContainer's padding so the rectangle doesn't interfere with the labels
    chart.plotContainer.paddingTop = 0;  // Adjust top padding to avoid cutting off labels
    chart.plotContainer.paddingBottom = 15;  // Adjust top padding to avoid cutting off labels

    // Hide the AmCharts logo
    // chart.logo.disabled = true;

    return () => {
      if (chart) {
        chart.dispose();
      }
    };
  }, [financials_data]);

  return <div ref={chartRef} style={{ width: "100%", height: "300px" }}></div>;
};

export default memo(Chart);